import { PropsWithChildren, useEffect, useState } from 'react';
import datadog from 'src/_shared/datadog';
import { DATADOG_CUSTOM_ACTIONS } from 'src/_shared/datadog/DatadogCustomActions';
import { BOOTSTRAP_CONTEXT, captureConnectionContext } from 'src/_shared/datadog/bootstrapContext';
import { FontsContext } from 'src/contexts/FontsContext';
import { useDebounceCallback } from 'src/hooks/useDebounceCallback';
import { useEditorCustomFonts, useEditorFonts } from 'src/hooks/useEditorFonts';

export const FontsProvider = ({ children }: PropsWithChildren) => {
  const [isLoadingCustomFonts, setIsLoadingCustomFonts] = useState(false);

  const { areMainFontsLoaded } = useEditorFonts();
  useEditorCustomFonts(isLoadingCustomFonts);

  const loadingCustomFonts = useDebounceCallback(() => {
    setIsLoadingCustomFonts(true);
  }, 100);

  useEffect(() => {
    if (areMainFontsLoaded) {
      datadog.endMeasure(DATADOG_CUSTOM_ACTIONS.bootstrap_fonts_ready, { ...BOOTSTRAP_CONTEXT, ...captureConnectionContext() });
    }
  }, [areMainFontsLoaded]);

  return <FontsContext.Provider value={{ loadingCustomFonts, areMainFontsLoaded }}>{children}</FontsContext.Provider>;
};
